
<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-5 no-gutter">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <web-service-configuration-form :key="formKey" v-model="config" :readonly="!editMode" :mode="mode"></web-service-configuration-form>
      <b-row class="justify-content-end mt-3 no-gutters">
        <b-button v-if="mode === 'create'"
        @click="createConfig" variant="primary">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
        <b-button class="mr-3" v-if="canEditConfig"
        @click="editModeActivate" variant="primary">
          <span>{{$t('common.routing.edit_this_config')}}</span>
        </b-button>
        <b-button class="mr-3" v-if="canDeleteConfig"
        @click="deleteConfig" variant="primary">
          <i class="fa-light fa-trash"></i>
          <span>{{$t('common.routing.delete_config')}}</span>
        </b-button>
        <b-button class="mr-3" v-if="canResetConfig"
        @click="resetConfig" variant="primary">
          <i class="fa-light fa-clock-rotate-left"></i>
          <span>{{$t('common.routing.reset_config')}}</span>
        </b-button>
        <b-button variant="primary" v-if="canSaveConfig"
          @click="editConfig">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

// import FormAccordion from '@/components/common/FormAccordion.vue'
// import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
// import Spinner from '@/components/common/spinner.vue'
import WebServiceConfigurationForm from '@/pages/routing/WebServiceConfigurationForm.vue'

import {loadPage} from '@/helpers/routing'
// import { ca } from 'vuejs-datepicker/src/locale'


export default {
  name: 'WebServiceConfigurationDetails',
  components: {
    'back-button': backButton,
    // 'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    // 'spinner': Spinner,
    'web-service-configuration-form': WebServiceConfigurationForm
  },
  props: {
    mode: {
      type: String,
      default: "create"
    }
  },
  data () {
    return {
      activateSpinner: false,
      config: {},
      editMode: false,
      returnUrl: '/routing/configurationList/WEBSERVICE',
      savedConfig: [],
      formKey: 0
    }
  },
  computed: {
    canDeleteConfig () {
      return this.mode === 'details' && this.editMode === false && this.$engine.rights.rightIs('webServiceConfig_supprimer', true)
    },
    canEditConfig () {
      return this.mode === 'details' && this.editMode === false && this.$engine.rights.rightIs('webServiceConfig_editer', true)
    },
    canResetConfig () {
      return this.mode === 'details' && this.savedConfig.IdParent != 0 && this.savedConfig.IdParent != '' && this.editMode === true && this.$engine.rights.rightIs('webServiceConfig_editer', true)
    },
    canSaveConfig () {
      return this.mode === 'details' && this.editMode === true
    },
    pageTitle () {
      return this.mode === "details" ? this.$t('Webheader.webservice_details') : this.$t('Webheader.webservice_add')
    },
  },
  created () {
    this.activateSpinner = true

    if (this.mode === "details") {
      this.savedConfig = this.$engine.routing.config.clickedConfig
      this.fillFields()
      this.$engine.routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    createConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      if (this.config.sslActive === "1") {
        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: this.config.certificateConfig.type,
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          commonName: this.config.certificateConfig.cn,
          idPod: this.config.certificateConfig.idPod
        }

        this.$engine.security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: that.config.privateKeysConfig.name,
            privateKey: that.config.privateKeysConfig.privateKey,
            password: that.config.privateKeysConfig.password,
            passwordVerif: that.config.privateKeysConfig.passwordVerif,
            type: that.config.privateKeysConfig.type,
            idPod: that.config.privateKeysConfig.idPod
          }
          let params = {
            idCertificat: respCertificate.data.idCertificat
          }

          that.$engine.security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            params.Host = that.config.host,
            params.Port = that.config.port,
            params.URI = that.config.uri,
            params.SSLMode = that.config.sslActive,
            params.Name = that.config.name
            params.idPrivateKey = respPrivateKey.data.idPrivateKey
            that.$engine.routing.config.webService.create(params)
            .then(() => {
              that.$f7.modal({
                title: that.$t('common.routing.config_added'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
            })
          })
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      } else {
        let params = {
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          login: this.config.login,
          password: this.config.password
        }
        this.$engine.routing.config.webService.create(params)
        .then(() => {
          that.$f7.modal({
            title: that.$t('common.routing.config_added'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      }
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdWebService: that.savedConfig.IdWebService
              }
              that.$engine.routing.config.webService.delete(params)
              .then(() => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let idParent = this.savedConfig.IdParent
      let that = this

      if (this.formHasError()) {
        return
      }
      if (this.config.login===0) {
        this.config.oauth2ClientId2 = this.config.IdWebService2 || '';
      }
      else if (this.config.login===-1) {
          this.config.oauth2ClientId2 = null,
          this.config.Host2 = null,
          this.config.Port2 = null,
          this.config.Name2 = null,
          this.config.SSLMode2 = this.config.sslActive,
          this.config.URI2 = null,
          this.config.uriActive2 = null,
          this.config.URILabel2 = null
        }
        else{
          this.config.oauth2ClientId2 = null,
          this.config.Host2 = null,
          this.config.Port2 = null,
          this.config.Name2 = null,
          this.config.SSLMode2 = this.config.sslActive,
          this.config.URI2 = null,
          this.config.uriActive2 = null,
          this.config.URILabel2 = null
        }
      if (this.config.sslActive === "1") {
        let temp = this.config.name + " - OAuth2"
        let params = {
          IdOauth2Config: this.config.oauth2ClientId2,
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          URIActive: this.config.uriActive,
          URILabel: this.config.uriLabel,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          IdWebService: this.savedConfig.IdWebService,
          login: this.config.login,
          password: this.config.password,
          Host2: this.config.Host2,
          Port2: this.config.Port2,
          Name2: temp,
          Login2: this.config.Login2,
          Password2: this.config.Password2,
          URI2: this.config.URI2,
          URIActive2: this.config.uriActive2,
          URILabel2: this.config.URILabel2,
          SSLMode2: this.config.SSLMode2,
          IdParent : idParent,
          HeaderHttp: this.config.HeaderHttp,
          HeaderHttp2: this.config.HeaderHttp2
        }
        this.$engine.routing.config.webService.edit(params)
        .then(() => {
          that.okMessageBox(that.$t('common.routing.config_edited')),
          loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          this.okMessageBox(this.$t('common.routing.config_edition_error'))
        })
      } else {
        let temp = this.config.name + " - OAuth2"
        let params = {
          IdOauth2Config: this.config.oauth2ClientId2,
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          URIActive: this.config.uriActive,
          URILabel: this.config.uriLabel,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          IdWebService: this.savedConfig.IdWebService,
          login: this.config.login,
          password: this.config.password,
          Host2: this.config.Host2,
          Port2: this.config.Port2,
          Name2: temp,
          Login2: this.config.Login2,
          Password2: this.config.Password2,
          URI2: this.config.URI2,
          URIActive2: this.config.uriActive2,
          URILabel2: this.config.URILabel2,
          SSLMode2: this.config.SSLMode2,
          IdParent : idParent
        }
        this.$engine.routing.config.webService.edit(params)
        .then(() => {
          that.$f7.modal({
            title: that.$t('common.routing.config_edited'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_edition_error'))
        })
      }
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.host = this.savedConfig.Host
      this.config.name = this.savedConfig.Name
      this.config.port = this.savedConfig.Port
      this.config.uri = this.savedConfig.URI
      this.config.uriActive = this.savedConfig.URIActive
      this.config.uriLabel = this.savedConfig.URILabel
      this.config.sslActive = this.savedConfig.SSLMode
      this.config.login = this.savedConfig.Login
      this.config.password = this.savedConfig.Password
      this.config.IdWebService2 = this.savedConfig.IdWebService2
      this.config.Host2 = this.savedConfig.Host2
      this.config.Port2 = this.savedConfig.Port2
      this.config.Name2 = this.savedConfig.Name2
      this.config.Login2 = this.savedConfig.Login2
      this.config.Password2 = this.savedConfig.Password2
      this.config.SSLMode2 = this.savedConfig.SSLMode2
      this.config.URI2 = this.savedConfig.URI2
      this.config.URIActive2 = this.savedConfig.URIActive2
      this.config.URILabel2 = this.savedConfig.URILabel2
      this.config.HeaderHttp = this.savedConfig.HeaderHttp
      this.config.HeaderHttp2 = this.savedConfig.HeaderHttp2
      this.isAuthSystemActive = (this.savedConfig.Login !== undefined && this.savedConfig.Login.length !== 0);
      this.formKey++
    },
    formHasError () {
      const mandatoryFields = [
        { key: 'Host2', message: 'common.routing.host_missing' },
        { key: 'Port2', message: 'common.routing.port_missing' },
        { key: 'SSLMode2', message: 'common.routing.uri_missing' }
      ]
      for (const field of mandatoryFields) {
        const value = this.config[field.key]
        if ((value === undefined || value === null || value === '' ) && this.config.login === 0) {
          this.okMessageBox(this.$t(field.message)+" in authentification")
          return true
        }
        if (this.isAuthSystemActive && (this.config.login === "" && this.config.login!==0 || this.config.login == "##NULL##")) {
          this.okMessageBox(this.$t('common.routing.config_api_key_missing'))
          return true
      }
      }
      if (this.config.name === undefined || this.config.name.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      if (this.config.host === undefined || this.config.host.length === 0) {
        this.okMessageBox(this.$t('common.routing.host_missing'))
        return true
      }
      if (this.config.port === undefined || this.config.port.length === 0) {
        this.okMessageBox(this.$t('common.routing.port_missing'))
        return true
      }
      // if (this.config.uri === undefined || this.config.uri.length === 0) {
      //   this.okMessageBox(this.$t('common.routing.uri_missing'))
      //   return true
      // }
      if (this.config.sslActive === undefined || this.config.sslActive !== "0" && this.config.sslActive !== "1") {
        this.okMessageBox(this.$t('common.routing.wrong_ssl_active'))
        return true
      }
      if (this.config.sslActive === "1") {
        /*if (this.config.controlConfig === undefined || this.config.controlConfig.selectedVerif.length === 0) {
          this.okMessageBox(this.$t('common.global.ctrl_missing'))
          return true
        }
        if (this.config.certificateConfig === undefined) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.name === undefined || this.config.certificateConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.certificate === undefined || this.config.certificateConfig.certificate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_desc_missing'))
          return true
        }
        if (this.config.certificateConfig.type === undefined || this.config.certificateConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.certif_type_missing'))
          return true
        }
        if (this.config.certificateConfig.password === undefined || this.config.certificateConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.certificateConfig.passwordVerif === undefined || this.config.certificateConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }
        if (this.config.certificateConfig.startDate === undefined || this.config.certificateConfig.startDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_valid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.endDate === undefined || this.config.certificateConfig.endDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_unvalid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.cn === undefined || this.config.certificateConfig.cn.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_cn_missing'))
          return true
        }
        if (this.config.privateKeysConfig === undefined) {
          this.okMessageBox(this.$t('common.securityffff'))
          return true
        }
        if (this.config.privateKeysConfig.name === undefined || this.config.privateKeysConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_name_missing'))
          return true
        }
        if (this.config.privateKeysConfig.privateKey === undefined || this.config.privateKeysConfig.privateKey.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_desc_missing'))
          return true
        }
        if (this.config.privateKeysConfig.type === undefined || this.config.privateKeysConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.priv_key_type_missing'))
          return true
        }
        if (this.config.privateKeysConfig.password === undefined || this.config.privateKeysConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.privateKeysConfig.passwordVerif === undefined || this.config.privateKeysConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }*/
      }
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: '/routing/configurationList/WEBSERVICE'})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    getConfigWebService (idParent) {
      let params = {IdWebService : idParent}
      if (!this.$engine.rights.rightIs('super_admin', true)) {
        params.Norm = parseInt(this.$engine.user.getUserNorm())
      }
      let that = this
      return this.$engine.routing.config.webService.fetch(
        {IdWebService: idParent}
      ).then(resp => {
        let webServiceList = {
          IdWebService: idParent
        }
        webServiceList = resp.data.WebService
        return webServiceList
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    },

    resetConfig () {
      let idParent = this.savedConfig.IdParent
      let that = this
      let host = this.savedConfig.Host
      let name = this.savedConfig.Name
      let port = this.savedConfig.Port
      let sslActive = this.savedConfig.SSLMode
      let headerHttp = this.savedConfig.HeaderHttp
      let headerHttp2 = this.savedConfig.HeaderHttp2
      this.$f7.modal({
        title: this.$t('common.routing.config_reset_confirm'),
        buttons: [
          {
            text: this.$t('common.yes_label'),
            onClick: function () {
              let params = {
                IdWebService: that.savedConfig.IdWebService,
                Host: host,
                Port: port,
                Name : name,
                SSLMode : sslActive,
                IsReset : true,
                IdParent : idParent,
                HeaderHttp: headerHttp,
                HeaderHttp2: headerHttp2
              }
              that.$engine.routing.config.webService.edit(params)
              .then(() => {
                that.okMessageBox(that.$t('common.routing.config_edited')),
                loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
              })
              .catch(err => {
                errorMessageAlert(err, that)
              })
            }
          },
          {
            text: this.$t('common.no_label'),
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}

</script>
